import React from 'react'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core'
import classNames from 'classnames'
import { CheckBoxOutlineBlank } from '@material-ui/icons'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import mobileView from '../mobile.utils'
import LocationAutoCompleteField from '../locationAutoCompleteField'

const filterFieldStyle = { padding: '0 8px', width: mobileView ? '' : '200px' }
const labelStyle = { fontSize: '18px', marginTop: '22px' }

export const AssignmentFilters = ({
  t,
  filters,
  onChange,
  classes,
  statusOptions = [{ value: '', label: '' }],
  resetSelectedPage
}) => {
  const handleChange = (field) => (e) => {
    resetSelectedPage()
    onChange({
      ...filters,
      [field]: !!e.target
        ? e?.target.type === 'checkbox'
          ? e.target.checked
          : e.target.value
        : e
    })
  }

  const handleSelect = (field) => (value) => {
    onChange({ ...filters, [field]: value })
  }

  return (
    <div className={classNames(classes.searchField)}>
      <div
        className={classNames(classes.filterFields)}
        style={mobileView ? { paddingBottom: 0 } : {}}
      >
        {/* Job Title */}
        <div style={filterFieldStyle}>
          <TextField
            label={t('employer.assignments.col1')}
            value={filters.job_title}
            onChange={handleChange('job_title')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/* Location */}
        <div style={filterFieldStyle}>
          <LocationAutoCompleteField
            label={t('employer.assignments.col3')}
            value={filters.location}
            classes={classes}
            handleChange={handleChange}
            handleSelect={handleSelect}
            employerSide={true}
          />
        </div>

        {/* Status */}
        <div style={filterFieldStyle}>
          <FormControl
            fullWidth
            style={{ marginTop: mobileView ? '32px' : '' }}
          >
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('employer.assignments.status')}
            </InputLabel>
            <Select
              value={filters.status}
              onChange={handleChange('status')}
              className={classNames(classes.textField)}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Pinned Checkbox */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.pinned}
                  onChange={handleChange('pinned')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('employer.app.fld18')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>
      </div>
      <div className={classNames(classes.filterFields)}>
        {/* Page Size */}
        <div style={{ padding: '0 8px', width: '80px' }}>
          <FormControl fullWidth>
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('employer.app.fld17')}
            </InputLabel>
            <Select
              value={filters.pageSize}
              onChange={handleChange('pageSize')}
              className={classNames(classes.textField)}
            >
              {[10, 20, 50, 100].map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  )
}
